
import { Component, Prop, Vue } from 'vue-property-decorator';
import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import { ThemeConfModule } from '@/store/modules/theme';
import { ThemeConf } from '@/types/ThemeConf';
import { AppModule } from '@/store/modules/app';
const Theme = getModule(ThemeConfModule, store);
const AppState = getModule(AppModule, store);

@Component
export default class ThemedSlide extends Vue {
  @Prop() enableScrollIndication!: boolean;

  get themeConfig() :ThemeConf | null{
    return Theme.getTheme;
  }

  get cssVars() {
    return this.themeConfig && this.themeConfig.color_primary
      ? { color: this.themeConfig.color_primary }
      : {};
  }

  get customTemplateID() :string|null{
    return AppState.tableOfContents.referenceMaterial?.id ?? null;
  }
}
